import cx from 'classnames';
import { ACTIVE_SERVER_ID } from 'mk/settings';
import {
    adminclub_admin_log_url,
    adminclub_bazaar_buyers_url,
    adminclub_bazaar_category_url,
    adminclub_bazaar_moderators_life_url,
    adminclub_bazaar_moderators_url,
    adminclub_bazaar_sinners_url,
    adminclub_bazaar_url,
    adminclub_cms_url,
    adminclub_commenters_url,
    adminclub_computers_url,
    adminclub_counselling_questions_url,
    adminclub_dupla_hammer_url,
    adminclub_excluded_blogs_url,
    adminclub_groups_url,
    adminclub_hacker_url,
    adminclub_homepage_feed_posts_url,
    adminclub_images_url,
    adminclub_ips_url,
    adminclub_keywords_url,
    adminclub_newdupla_url,
    adminclub_notes_url,
    adminclub_permissions_url,
    adminclub_police_url,
    adminclub_pro_forum_url,
    adminclub_spam_url,
    adminclub_staffpicks_url,
    adminclub_strollers_questions_url,
    adminclub_strollers_reviews_url,
    adminclub_tagging_url,
    adminclub_threads_url,
    adminclub_tickets_url,
    adminclub_topics_url,
    adminclub_users_url,
    adminclub_wiki_experiences_url,
    i18n_list_url,
    mailing_list_url,
    market_admin_url,
    users_rookies_url,
} from 'mk/urls/functions';
import {
    adminclubConceptsHierarchyUrl,
    adminclubQuestionOfTheDayUrl,
    adminclubTaggingTabsUrl,
} from 'mk2/apps/adminclub/urls';
import { CompatibleLink } from 'mk2/containers/SiteMenu/SiteMenu';
import { hasRequiredPermissions } from 'mk2/helpers/permissions';
import { MapDispatchToPropsObject } from 'mk2/helpers/types';
import { url } from 'mk2/helpers/urls';
import { AppState, getRequestPermissions } from 'mk2/reducers';
import { HeaderMenuItem, MenuSelection } from 'mk2/schemas';
import React from 'react';
import { connect } from 'react-redux';
import styles from './AdminclubHeader.mscss';

interface AdminclubTabDefinition {
    name: string;
    title: string;
    url: string;
    permission: string | string[];
}

export const ADMINCLUB_TABS: AdminclubTabDefinition[] = [
    {name: 'users', title: 'Users', url: adminclub_users_url(), permission: 'users.can_manage_users'},
    {name: 'tickets', title: 'Tickets', url: adminclub_tickets_url(), permission: 'users.can_manage_users'},
    {name: 'forum/*', title: 'Discussions', url: adminclub_threads_url(), permission: 'forum.can_manage_forum'},
    {name: 'rookies', title: 'Rookies', url: users_rookies_url(), permission: 'users.can_manage_users'},
    {name: 'ips', title: 'IPs', url: adminclub_ips_url(), permission: 'users.can_manage_users'},
    {name: 'computers', title: 'Computers', url: adminclub_computers_url(), permission: 'users.can_manage_users'},
    {name: 'pro-forum', title: 'PRO forum', url: adminclub_pro_forum_url(), permission: 'vendor.can_manage_pro'},
    {name: 'bazaar/*', title: 'Bazaar', url: adminclub_bazaar_url(), permission: 'bazaar.can_manage_bazaar'},
    {name: 'notes', title: 'Notes', url: adminclub_notes_url(), permission: 'users.can_manage_notes'},
    {name: 'staffpicks', title: 'Staff picks', url: adminclub_staffpicks_url(), permission: 'photoblog.can_manage_blogs'},
    {name: 'spam', title: 'Spam', url: adminclub_spam_url(), permission: 'users.can_manage_users'},
    {name: 'perms', title: 'Permissions', url: adminclub_permissions_url(), permission: 'users.can_manage_permissions'},
    {name: 'groups', title: 'Groups', url: adminclub_groups_url(), permission: 'users.can_manage_groups'},
    {name: 'emails', title: 'Email templates', url: mailing_list_url(), permission: 'i18n.can_manage_translations'},
    {name: 'log', title: 'Admin log', url: adminclub_admin_log_url(), permission: 'users.can_manage_admin_log'},
    {name: 'cms', title: 'CMS', url: adminclub_cms_url(), permission: 'i18n.can_manage_translations'},
    {name: 'excluded', title: 'Excluded blogs', url: adminclub_excluded_blogs_url(), permission: 'users.can_manage_excluded_blogs'},
    {name: 'hammer', title: 'Duplas', url: adminclub_dupla_hammer_url(), permission: 'users.can_manage_users'},
    {name: 'i18n', title: 'Translations', url: i18n_list_url(), permission: 'i18n.can_manage_translations'},
    {name: 'keywords', title: 'Keywords', url: adminclub_keywords_url(), permission: 'system.can_manage_watched_keywords'},
    {name: 'commenters', title: 'Commenters', url: adminclub_commenters_url(), permission: 'users.can_manage_users'},
    {name: 'newdupla', title: 'New Dupla', url: adminclub_newdupla_url(), permission: 'users.can_manage_users'},
    {name: 'strollers_questions', title: 'Strollers (questions)', url: adminclub_strollers_questions_url(), permission: 'auth.can_manage_strollers'},
    {name: 'strollers_reviews', title: 'Strollers (reviews)', url: adminclub_strollers_reviews_url(), permission: 'auth.can_manage_strollers'},
    {name: 'wiki_experiences', title: 'Wiki (experiences)', url: adminclub_wiki_experiences_url(), permission: 'wiki.can_edit_wiki'},
    {name: 'counselling_questions', title: 'Counselling', url: adminclub_counselling_questions_url(), permission: 'forum.can_manage_forum'},
    {name: 'homepage_feed_posts', title: 'Homepage', url: adminclub_homepage_feed_posts_url(), permission: 'homepage.can_manage_homepage'},
    {name: 'hacker', title: 'Hacker', url: adminclub_hacker_url(), permission: 'users.can_develop'},
    {name: 'police', title: 'Police', url: adminclub_police_url(), permission: 'users.can_develop'},
    {name: 'images', title: 'Images', url: adminclub_images_url(), permission: 'users.can_develop'},
    {name: HeaderMenuItem.AdminclubConceptsHierarchy, title: 'Concepts Hierarchy', url: adminclubConceptsHierarchyUrl, permission: 'forum.can_manage_forum'},
    {name: 'tagging', title: 'Tagging', url: adminclub_tagging_url(), permission: 'forum.can_manage_forum'},
];

export const ADMINCLUB_BAZAAR_SUBTABS: AdminclubTabDefinition[] = [
    {name: HeaderMenuItem.AdminclubBazaarUser, title: 'User Details', url: adminclub_bazaar_url(), permission: 'bazaar.can_manage_bazaar'},
    {name: HeaderMenuItem.AdminclubBazaarSinners, title: 'Sinners', url: adminclub_bazaar_sinners_url(), permission: 'bazaar.can_manage_bazaar'},
    {name: HeaderMenuItem.AdminclubBazaarBuyers, title: 'Communication', url: adminclub_bazaar_buyers_url(), permission: 'bazaar.can_manage_bazaar'},
    {name: HeaderMenuItem.AdminclubBazaarCategory, title: 'Analyze Category', url: adminclub_bazaar_category_url(), permission: 'bazaar.can_manage_bazaar' },
    {name: HeaderMenuItem.AdminclubBazaarModerators, title: 'Moderators', url: adminclub_bazaar_moderators_url(), permission: 'bazaar.can_manage_bazaar'},
    {name: HeaderMenuItem.AdminclubBazaarModeratorsLife, title: 'ModeratorsLife', url: adminclub_bazaar_moderators_life_url(), permission: 'bazaar.can_manage_bazaar'},
    {name: HeaderMenuItem.AdminclubBazaarBulkEdit, title: 'Bulk edit', url: market_admin_url(), permission: 'bazaar.can_manage_bazaar'},
];

export const ADMINCLUB_FORUM_SUBTABS: AdminclubTabDefinition[] = [
    {name: HeaderMenuItem.AdminclubForumThreads, title: 'Discussions', url: adminclub_threads_url(), permission: 'forum.can_manage_forum'},
    {name: HeaderMenuItem.AdminclubForumTopics, title: 'Topics', url: adminclub_topics_url(), permission: 'forum.can_manage_forum'},
    {name: HeaderMenuItem.AdminclubTaggingGroups, title: 'Groups', url: url(adminclubTaggingTabsUrl, {tab: 'groups'}), permission: ''},
    {name: HeaderMenuItem.AdminclubTaggingBlogArticles, title: 'Blog articles', url: url(adminclubTaggingTabsUrl, {tab: 'articles'}), permission: ''},
];

if (ACTIVE_SERVER_ID === 201) {
    // Question of the day for VIBER is only on SK account
    ADMINCLUB_TABS.push({
        name: HeaderMenuItem.AdminclubQuestionOfTheDay,
        title: 'Question of the Day',
        url: adminclubQuestionOfTheDayUrl,
        permission: 'forum.can_manage_forum',
    });
}

interface OwnProps {
    menuSelection?: MenuSelection;
    fluxibleCompatibility: boolean;
}

interface StateProps {
    requestUserPermissions: string[];
}

interface DispatchProps {}

type Props = OwnProps & StateProps & DispatchProps;

class AdminclubHeader extends React.PureComponent<Props> {
    public render() {
        const { menuSelection, fluxibleCompatibility } = this.props;
        const activeItem = menuSelection && menuSelection.activeItem;

        let subTabs;
        if (ADMINCLUB_BAZAAR_SUBTABS.map((td) => td.name).indexOf(activeItem) >= 0) {
            subTabs = ADMINCLUB_BAZAAR_SUBTABS;
        } else if (ADMINCLUB_FORUM_SUBTABS.map((td) => td.name).indexOf(activeItem) >= 0) {
            subTabs = ADMINCLUB_FORUM_SUBTABS;

        } else {
            subTabs = null;
        }

        return (
            <React.Fragment>
                <div className={styles.AdminclubHeader}>
                    {this.renderTabs(activeItem)}
                </div>

                {!!subTabs && (
                    <div className={styles.AdminclubHeader__subMenu}>
                        <div className={styles.AdminclubHeader__subTabs}>
                            {subTabs.map((subtab) => (
                                <CompatibleLink
                                    key={subtab.name}
                                    className={cx(
                                        styles.AdminclubHeader__subTab,
                                        (activeItem === subtab.name) && styles['AdminclubHeader__subTab--selected'],
                                    )}
                                    to={subtab.url}
                                    fluxibleCompatibility={fluxibleCompatibility}
                                >
                                    {subtab.title}
                                </CompatibleLink>
                            ))}
                        </div>
                    </div>
                )}
            </React.Fragment>
        );
    }

    private renderTabs(activeItem: string) {
        const { requestUserPermissions, fluxibleCompatibility } = this.props;

        if (ADMINCLUB_FORUM_SUBTABS.map((td) => td.name).indexOf(activeItem) >= 0) {
            activeItem = 'forum/*';
        } else if (ADMINCLUB_BAZAAR_SUBTABS.map((td) => td.name).indexOf(activeItem) >= 0) {
            activeItem = 'bazaar/*';
        }

        return (
            <div className={styles.AdminclubHeader__tabs}>
                {ADMINCLUB_TABS.map((tab, i) => (hasRequiredPermissions(requestUserPermissions, tab.permission)
                    ? (
                        <CompatibleLink
                            key={tab.name}
                            className={cx(
                                styles.AdminclubHeader__tab,
                                (activeItem === tab.name) && styles['AdminclubHeader__tab--selected'],
                            )}
                            to={tab.url}
                            fluxibleCompatibility={tab.name !== 'concepts-hierarchy' || fluxibleCompatibility}
                        >
                            {tab.title}
                        </CompatibleLink>
                    ) : null
                ))}
            </div>
        );
    }

}

function mapStateToProps(state: AppState, ownProps: OwnProps): StateProps {
    return {
        requestUserPermissions: getRequestPermissions(state),
    };
}

const mapDispatchToProps: MapDispatchToPropsObject<DispatchProps> = {};

export default connect(mapStateToProps, mapDispatchToProps)(AdminclubHeader);
